import React, { useState, useEffect } from "react";
import axios from "axios";
import MaterialTable from "material-table";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'


import Helper from "../../../../../Helper";
import { getTrans as t } from "../../../../../Localization/translations";
import { API } from "../../../../../backend";
import authHeader from "../../../../../services/auth-header";

const ContractPaymentDetails = ({
  contractDate,
  paymentRule,
  payment_count,
  paymentFrequency,
  noTerms,
  items,
  contract_type,
  paymentdetails
}) => {
  const [paymentDates, setPaymentDates] = useState([]);
  const [feedefination, setFeeDefination] = useState([]);
  const FeeDefination = () => {
    let url =
      API +
      "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setFeeDefination(response.data))
  };
  useEffect(() => {
    FeeDefination();
  }, []);
  const getLastDayOfMonth = (year, month) => {
    return new Date(year, month + 1, 0);
  };
  useEffect(() => {
    if (contract_type === "Lease"){
      
      setPaymentDates(paymentdetails)
    }
    else{

    
    if (paymentFrequency && payment_count > 0) {
      const contractDateObj = new Date(contractDate);
      const frequencyMapping = {
        Monthly: 1,
        Quarterly: 3,
        "Semi-annual": 6,
        Annual: 12,
      };

      const calculatedPaymentDates = [];
      let currentDate = contractDateObj;
      let paymentStartDate = null;
      let lastPaymentType = [];
      let startDate = null;
      let endDate = null;

      items.forEach((item, index) => {
        const { amount, no_of_payments, payment_type, start_date, end_date } =
          item;
        const filterfeenature = feedefination.filter(
          (value) => value.fee_name === payment_type
        );
        const isLastDayOfMonth =
          currentDate.getDate() ===
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth() + 1,
            0
          ).getDate();
        currentDate = new Date(start_date);
        if (amount >=0 && no_of_payments > 0) {
          if (paymentRule === "Advance") {
            if (typeof lastPaymentType[payment_type] === "undefined") {
              paymentStartDate = contractDateObj;
            } else {
              paymentStartDate = lastPaymentType[payment_type];
            }
          } else if (paymentRule === "Arrears") {
            const cycleMonths = frequencyMapping[paymentFrequency];
            if (typeof lastPaymentType[payment_type] === "undefined") {
              paymentStartDate = new Date(
                contractDateObj.getFullYear(),
                contractDateObj.getMonth() + cycleMonths,
                contractDateObj.getDate()
              );
            } else {
              paymentStartDate = lastPaymentType[payment_type];
            }
          }

          let calculatedNoTerms;
          switch (paymentFrequency) {
            case "Monthly":
              calculatedNoTerms = parseInt(noTerms) / 1;
              break;
            case "Quarterly":
              calculatedNoTerms = parseInt(noTerms) / 3;
              break;
            case "Annual":
              calculatedNoTerms = parseInt(noTerms) / 12;
              break;
            case "Semi-annual":
              calculatedNoTerms = parseInt(noTerms) / 6;
              break;
            default:
              throw new Error("Invalid payment frequency");
          }

          for (let i = 0; i < no_of_payments; i++) {
            if (isLastDayOfMonth === true) {
              startDate = new Date(
                paymentStartDate.getFullYear(),
                paymentStartDate.getMonth(),
                paymentStartDate.getDate() // Add one day to the start date
              );
            } else {
              if (paymentRule ==='Advance'){
                
                startDate = new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth() ,
                  currentDate.getDate() // Add one day to the start date
                );
              }
              else{
                startDate = new Date(
                  currentDate.getFullYear(),
                  // currentDate.getMonth() - frequencyMapping[paymentFrequency],
                  currentDate.getMonth() ,
                  currentDate.getDate() // Add one day to the start date
                );
              }
            }
            if (isLastDayOfMonth === true) {
              let lastDayCurrentMonth = getLastDayOfMonth(
                startDate.getFullYear(),
                startDate.getMonth() + frequencyMapping[paymentFrequency]
              );
              endDate = new Date(
                startDate.getFullYear(),
                startDate.getMonth() + frequencyMapping[paymentFrequency],
                lastDayCurrentMonth.getDate() - 1
              );
            } else {
              endDate = new Date(
                startDate.getFullYear(),
                startDate.getMonth() + frequencyMapping[paymentFrequency],
                currentDate.getDate() - 1
              );
            }
            if (filterfeenature.length !== 0) {
              if (filterfeenature[0].fee_nature === "One Time") {
                startDate = new Date(start_date);
                endDate = new Date(end_date);
              }
            }

            const paymentEntry = {
              // paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(endDate) : Helper.DatePicker(paymentStartDate),
              paymentdate: paymentRule === "Arrears" ? Helper.DatePicker(paymentStartDate) : Helper.DatePicker(paymentStartDate),
              startdate: Helper.DatePicker(startDate),
              enddate: Helper.DatePicker(endDate),
              periodicamount: amount,
              txn_number: `TRAN${index + 1}`,
              payment_type: payment_type,
            };

            calculatedPaymentDates.push(paymentEntry);

            currentDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() + frequencyMapping[paymentFrequency],
              currentDate.getDate()
            );

            if (isLastDayOfMonth === true) {
              paymentStartDate = new Date(
                endDate.getFullYear(),
                endDate.getMonth() + 1,
                0
              );
            } else {
              paymentStartDate = new Date(
                paymentStartDate.getFullYear(),
                paymentStartDate.getMonth() +
                frequencyMapping[paymentFrequency],
                paymentStartDate.getDate()
              );
            }
          }

          lastPaymentType[payment_type] = paymentStartDate;
        }
      });
      calculatedPaymentDates.sort((a, b) => {
        const dateA = new Date(a.paymentdate);
        const dateB = new Date(b.paymentdate);
        return dateA - dateB;
      });
      setPaymentDates(calculatedPaymentDates);
    }
  }
  }, [contractDate, paymentRule, paymentFrequency, noTerms, items,paymentdetails]);
  return (
    <>
      <div className="mt">
        <MaterialTable
          style={{
            backgroundColor: "var(--bs-table-bg)",
            borderBottomWidth: "1px",
            boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
          }}
          title={<h5 className="mb-0">{t("Payment Details")}</h5>}
          columns={[
            {
              title: `${t("Payment Date")}`,
              field: "paymentdate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Date")}</div>
                  <div>{Helper.DateNormal(rowData.paymentdate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Payment Type")}`,
              field: "paymenttype",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}</div>
                  <div>{rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Start Date")}`,
              field: "startdate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Start Date")}</div>
                  <div>{Helper.DateNormal(rowData.startdate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("End Date")}`,
              field: "enddate",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("End Date")}</div>
                  <div>{Helper.DateNormal(rowData.enddate)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Amount")}`,
              field: "periodicamount",
              render: (rowData) => (
                <>
                  <div className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                  >{t("Amount")}</div>
                  <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.periodicamount)}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "right",
              },
              // cellStyle: {
              //   textAlign: "right",
              //   fontSize: 12,
              // },
            },
            {
              title: `${t("Date Billed")}`,
              field: "date_billed",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Date Billed")}</div>
                  <div>
                    {rowData.date_billed
                      ? Helper.DateNormal(rowData.date_billed)
                      : ""}
                  </div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
            {
              title: `${t("Invoice Number")}`,
              field: "transaction_number",
              render: (rowData) => (
                <>
                  <div className="d-xl-none tc d-md-none d-lg-none">{t("Invoice Number")}</div>
                  {/* <div>{rowData.paymentdetail_id}</div> */}
                  <div>{rowData.transaction_number
                                      ? rowData.transaction_number
                                      : ""}</div>
                </>
              ),
              headerStyle: {
                verticalAlign: "inherit",
                fontWeight: "bold",
                textAlign: "left",
              },
              cellStyle: {
                textAlign: "left",
                fontSize: 12,
              },
            },
          ]}
          data={paymentDates}
          localization={{
            toolbar: {
              searchPlaceholder: "Search Contracts",
            },
          }}
          options={{
            headerStyle: {
              backgroundColor: "white",
              color: "#245C7F",
              fontSize: 11,
            },
            rowStyle: (rowData, index) => {
              if (index % 2) {
                return { backgroundColor: "#fff" };
              }
            },
            sorting: true,
            search: false,
            toolbar: true,
            paging: true,
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [10, 20, 25, 50],
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            exportAllData: true,
            exportButton: true,
            exportFileName: "Payment Detail",
            exportPdf: (data, columns) => {
              const doc = new jsPDF();
              const columnTitles = data.map((columnDef) => columnDef.title);

              const pdfData = columns.map((rowData) =>
                data.map((columnDef) => rowData[columnDef.field])
              );
              // doc.autoTable({
              autoTable(doc,{
                head: [columnTitles],
                body: pdfData,
              });

              doc.save(`contract.pdf`);
            },
            actionsColumnIndex: -1,
          }}
        />
      </div>
    </>
  );
};

export default ContractPaymentDetails;
